// entities/product/lib/menuAvailability
//
// Доступность позиции каталога — общая и для набора, и для комбо: бэк отдаёт причину
// одним словарём (MenuAvailabilityService), фронт одинаково её показывает.

import type { BundleStepProductUnavailableReason } from '../model/types/bundle'

/** Всё, что бэк умеет помечать недоступным: товар шага набора, товар слота комбо. */
export interface MenuAvailabilityAware {
  is_available?: boolean
  unavailable_reason?: BundleStepProductUnavailableReason | null
}

/**
 * Товар доступен, если бэк явно не сказал обратное. Поля `is_available` не было в первых
 * версиях ответа, поэтому отсутствие флага — это «доступен», а не «неизвестно».
 */
export const isMenuItemAvailable = (item: MenuAvailabilityAware): boolean =>
  item.is_available !== false

/** Короткая подпись на карточке — гость должен понимать, почему нельзя. */
const UNAVAILABLE_LABELS: Record<string, string> = {
  stop_list: 'Закончился',
  not_in_branch: 'Нет в этом ресторане',
  inactive: 'Нет в меню',
  // Гостю разницы нет: товара нет в меню, потому что админ выключил его группу
  inactive_group: 'Нет в меню',
}

export const menuUnavailableLabel = (item: MenuAvailabilityAware): string =>
  UNAVAILABLE_LABELS[item.unavailable_reason ?? ''] ?? 'Недоступен'

/** Пояснение в тосте, когда гость всё-таки ткнул в перечёркнутую карточку. */
export const menuUnavailableHint = (item: MenuAvailabilityAware): string =>
  item.unavailable_reason === 'stop_list'
    ? 'Товар закончился и вернётся, как только его приготовят. Выберите другой вариант.'
    : 'Этого товара нет в меню выбранного ресторана. Выберите другой вариант.'
